export const specials = {
  DISPATCH_SMUR: 'dispatch_smur',
  PATIENT_AGE: 'patient_age',
};
